define('form/upload/dragdropupload',['jquery', 'lib/jquery.fileupload'], function ($) { 
	
	/**
	 * Uploader
	 * @author Han van der Veen
	 * 
	 * Combineert DragDrop Upload en Uploadify voor backwards compatible
	 * Combineert beide in 1 queue
	 * 
	 * TODO Error afhandeling mooier
	 * TODO Dingen uit de queue verwijderen
	 */
	/**
	 * DragDropUpload
	 * 
	 * Settings
	 * 	element: droparea
	 * 	script: where to upload to
	 * 	extentions: string of extentions, format: '*.[ext];*.[ext]' or *.* for all
	 * 	data: extra data to post to server
	 * 	uploaderParent: een parent die de functies heeft zoals queue, progress, error en complete
	 * 	onEnter: drag over
	 * 	onLeave: drag leave
	 */
	var DragDropUpload = function (args) {
		var settings = {
			element : null,
			script : '',
			extensions : '*.*',
			data : {},
			count : 0,
			uploaderParent : null,
			onEnter : function () {},
			onLeave : function () {}
		};
		$.extend(settings, args);

		var iComplete = 0;
		
		$(settings.element)
	    .bind('fileuploaddone', function (event, data) { // Complete, emulate completeAll
			settings.uploaderParent.complete(event, data);
			
			iComplete++;

			if(iComplete == data.originalFiles.length) {
				settings.uploaderParent.completeAll(event, data);
			}
	    })
	    .bind('fileuploadfail', settings.uploaderParent.error) // Error
	    .bind('fileuploadprogress', settings.uploaderParent.progress) // Progress
	    .bind('fileuploadprogressall', settings.uploaderParent.progressAll) // ProgressAll
	    .bind('fileuploadadd', settings.uploaderParent.queue) // Queue (add)
	    .bind('fileuploadsend', function (event, data) { // BeforeSend, extentie check
			var ext = settings.extensions.split(';');
			var correct = false;
			$.each(ext, function () {
				if(this != '*.*') {
					var prep = this.replace('*.','\\\.');
					prep += '$';
					var file = data.files[0].name;
					if(file.match(new RegExp(prep, 'i')) !== null) {
						correct = true;
					}
				} else {
					correct = true;
				} 
			});
			// geen true teruggeven, alleen false, anders niets return correct mag dus niet
			if(correct === false) {
				return false;
			}
	    })
		.bind('fileuploadstart', function (e) { // init van upload
			iComplete = 0;
		});
		
		// effects
		$(settings.element).bind('dragenter', settings.onEnter);
		$(settings.element).bind('dragover', settings.onEnter);
		$(settings.element).bind('dragleave', settings.onLeave);

		// Init fileUpload API, rest via events
		$(settings.element).fileupload({
		    dropZone: $(settings.element),
		    url : settings.script,
		    dataType : 'json',
		    formData : settings.data,
		    paramName : 'file',
			limitConcurrentUploads: 3
		});
		
	};
	
	return DragDropUpload;
	
});
